const Footer = ({ socialLinks = {} }) => {
  const infoTitle = 'KURUMSAL';
  const subTitle = "NTV'yi Keşfedin";
  const InfoList = [
    'Kullanım Koşulları',
    'Gizlilik Politikası',
    'Çerez (Cookie) Politikası',
    'Reklam',
    'Künye',
    'İletişim',
    'İzleyici Temsilci',
    'Bize Ulaşın',
    'İnsan Kaynakları',
  ];

  const InfoLane = () => {
    return (
      <div className='footer-about'>
        <div className='container'>
          <div className='content'>
            <ul>
              <h4>{infoTitle}</h4>
              {InfoList.map(function (each, key) {
                return <li key={key}>{each}</li>;
              })}
            </ul>
          </div>
        </div>
      </div>
    );
  };

  const SocialLane = () => {
    return (
      <div className='social-info'>
        <div className='container'>
          <div className='content'>
            <ul>
              <li>{subTitle}</li>

              {/* Twitter */}
              {socialLinks.twitter?.indexOf('twitter') !== -1 ? (
                <li>
                  <a
                    href={socialLinks.twitter}
                    target='_blank'
                    alt='Twitter'
                    rel='noreferrer'
                  >
                    <svg
                      width='25'
                      height='22'
                      viewBox='0 0 25 22'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M0 18.8468C2.6564 18.9995 4.97931 18.3651 7.24472 16.6852C4.95631 16.2858 3.36937 15.2168 2.50691 13.0082C3.17388 12.9143 3.76036 13.0905 4.45033 12.8085C2.19642 11.7983 0.735974 10.2828 0.678476 7.66313C1.39145 7.72187 1.93193 8.20351 2.7829 8.13303C0.712981 6.06547 0.0804968 3.80994 1.37995 1.07277C3.54186 3.61024 6.07177 5.33712 9.16515 6.1477C9.33764 6.19469 9.49863 6.24168 9.67112 6.27692C10.4646 6.46488 11.4076 6.8643 11.8905 6.80556C12.7185 6.69983 11.8905 5.72479 12.0975 4.45606C12.753 0.508894 17.0078 -1.28848 20.1587 1.02578C21.0787 1.70714 21.8031 1.69539 22.7116 1.28423C23.1831 1.07277 23.6661 0.86132 24.2296 0.614622C24.1031 1.74238 23.2521 2.365 22.5736 3.19907C23.3441 3.37529 23.9651 3.15208 24.678 2.91713C24.4365 3.72771 23.8386 4.18587 23.2981 4.63227C22.7346 5.09042 22.5161 5.57207 22.4931 6.32391C22.1481 17.7073 9.48714 26.5061 0.827976 19.5046C-0.0114911 18.8233 0.804969 19.5046 0 18.8468Z'
                        fill='#819099'
                      />
                    </svg>
                  </a>
                </li>
              ) : (
                <li>
                  <svg
                    width='25'
                    height='22'
                    viewBox='0 0 25 22'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M0 18.8468C2.6564 18.9995 4.97931 18.3651 7.24472 16.6852C4.95631 16.2858 3.36937 15.2168 2.50691 13.0082C3.17388 12.9143 3.76036 13.0905 4.45033 12.8085C2.19642 11.7983 0.735974 10.2828 0.678476 7.66313C1.39145 7.72187 1.93193 8.20351 2.7829 8.13303C0.712981 6.06547 0.0804968 3.80994 1.37995 1.07277C3.54186 3.61024 6.07177 5.33712 9.16515 6.1477C9.33764 6.19469 9.49863 6.24168 9.67112 6.27692C10.4646 6.46488 11.4076 6.8643 11.8905 6.80556C12.7185 6.69983 11.8905 5.72479 12.0975 4.45606C12.753 0.508894 17.0078 -1.28848 20.1587 1.02578C21.0787 1.70714 21.8031 1.69539 22.7116 1.28423C23.1831 1.07277 23.6661 0.86132 24.2296 0.614622C24.1031 1.74238 23.2521 2.365 22.5736 3.19907C23.3441 3.37529 23.9651 3.15208 24.678 2.91713C24.4365 3.72771 23.8386 4.18587 23.2981 4.63227C22.7346 5.09042 22.5161 5.57207 22.4931 6.32391C22.1481 17.7073 9.48714 26.5061 0.827976 19.5046C-0.0114911 18.8233 0.804969 19.5046 0 18.8468Z'
                      fill='#819099'
                    />
                  </svg>
                </li>
              )}

              {/* Facebook */}
              {socialLinks.facebook?.indexOf('facebook') !== -1 ? (
                <li>
                  <a
                    href={socialLinks.facebook}
                    target='_blank'
                    alt='Facebook'
                    rel='noreferrer'
                  >
                    <svg
                      width='13'
                      height='22'
                      viewBox='0 0 13 22'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M7.69312 12.7899V22H3.49099V12.7899H0V9.05547H3.49099V7.69675C3.49099 2.65237 5.58398 0 10.0124 0C11.37 0 11.7094 0.219675 12.4528 0.398669V4.09246C11.6205 3.94601 11.3861 3.86465 10.5215 3.86465C9.49518 3.86465 8.94567 4.15754 8.44465 4.73521C7.94363 5.31287 7.69312 6.31361 7.69312 7.74556V9.06361H12.4528L11.176 12.7981H7.69312V12.7899Z'
                        fill='#819099'
                      />
                    </svg>
                  </a>
                </li>
              ) : (
                <li>
                  <svg
                    width='13'
                    height='22'
                    viewBox='0 0 13 22'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M7.69312 12.7899V22H3.49099V12.7899H0V9.05547H3.49099V7.69675C3.49099 2.65237 5.58398 0 10.0124 0C11.37 0 11.7094 0.219675 12.4528 0.398669V4.09246C11.6205 3.94601 11.3861 3.86465 10.5215 3.86465C9.49518 3.86465 8.94567 4.15754 8.44465 4.73521C7.94363 5.31287 7.69312 6.31361 7.69312 7.74556V9.06361H12.4528L11.176 12.7981H7.69312V12.7899Z'
                      fill='#819099'
                    />
                  </svg>
                </li>
              )}

              {/* İnstagram */}
              {socialLinks.instagram?.indexOf('instagram') !== -1 ? (
                <li>
                  <a
                    href={socialLinks.instagram}
                    target='_blank'
                    alt='Instagram'
                    rel='noreferrer'
                  >
                    <svg
                      width='22'
                      height='22'
                      viewBox='0 0 22 22'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M18.3228 21H3.67721C2.20567 21 1 19.7943 1 18.3228V3.67721C1 2.20567 2.20567 1 3.67721 1H18.3228C19.7943 1 21 2.20567 21 3.67721V18.3228C21 19.8034 19.8034 21 18.3228 21Z'
                        stroke='#819099'
                        strokeWidth='2'
                      />
                      <path
                        d='M14.8862 15.2119L14.8865 15.2116C15.991 14.1268 16.6 12.6827 16.6 11.1468C16.6 9.6109 15.991 8.16678 14.8865 7.08204C13.782 5.99736 12.3123 5.4 10.75 5.4C9.18768 5.4 7.71803 5.99736 6.61353 7.08204C5.50897 8.16678 4.9 9.6109 4.9 11.1468C4.9 12.6827 5.50897 14.1268 6.61353 15.2116C7.71803 16.2963 9.18768 16.8936 10.75 16.8936C12.3126 16.8936 13.7728 16.2961 14.8862 15.2119ZM6.3236 11.1468C6.3236 8.74638 8.31018 6.80164 10.75 6.80164C13.1893 6.80164 15.1673 8.75489 15.1764 11.1469C15.1763 13.5473 13.1898 15.492 10.75 15.492C8.30125 15.492 6.3236 13.5385 6.3236 11.1468Z'
                        fill='#819099'
                        stroke='#819099'
                        strokeWidth='0.2'
                      />
                      <path
                        d='M17.7522 5.17213C18.351 5.17213 18.8364 4.6867 18.8364 4.08791C18.8364 3.48911 18.351 3.00369 17.7522 3.00369C17.1534 3.00369 16.668 3.48911 16.668 4.08791C16.668 4.6867 17.1534 5.17213 17.7522 5.17213Z'
                        fill='#819099'
                      />
                    </svg>
                  </a>
                </li>
              ) : (
                <li>
                  <svg
                    width='22'
                    height='22'
                    viewBox='0 0 22 22'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M18.3228 21H3.67721C2.20567 21 1 19.7943 1 18.3228V3.67721C1 2.20567 2.20567 1 3.67721 1H18.3228C19.7943 1 21 2.20567 21 3.67721V18.3228C21 19.8034 19.8034 21 18.3228 21Z'
                      stroke='#819099'
                      strokeWidth='2'
                    />
                    <path
                      d='M14.8862 15.2119L14.8865 15.2116C15.991 14.1268 16.6 12.6827 16.6 11.1468C16.6 9.6109 15.991 8.16678 14.8865 7.08204C13.782 5.99736 12.3123 5.4 10.75 5.4C9.18768 5.4 7.71803 5.99736 6.61353 7.08204C5.50897 8.16678 4.9 9.6109 4.9 11.1468C4.9 12.6827 5.50897 14.1268 6.61353 15.2116C7.71803 16.2963 9.18768 16.8936 10.75 16.8936C12.3126 16.8936 13.7728 16.2961 14.8862 15.2119ZM6.3236 11.1468C6.3236 8.74638 8.31018 6.80164 10.75 6.80164C13.1893 6.80164 15.1673 8.75489 15.1764 11.1469C15.1763 13.5473 13.1898 15.492 10.75 15.492C8.30125 15.492 6.3236 13.5385 6.3236 11.1468Z'
                      fill='#819099'
                      stroke='#819099'
                      strokeWidth='0.2'
                    />
                    <path
                      d='M17.7522 5.17213C18.351 5.17213 18.8364 4.6867 18.8364 4.08791C18.8364 3.48911 18.351 3.00369 17.7522 3.00369C17.1534 3.00369 16.668 3.48911 16.668 4.08791C16.668 4.6867 17.1534 5.17213 17.7522 5.17213Z'
                      fill='#819099'
                    />
                  </svg>
                </li>
              )}

              {/* Youtube */}
              {socialLinks.youtube?.indexOf('youtube') !== -1 ? (
                <li>
                  <a
                    href={socialLinks.youtube}
                    target='_blank'
                    alt='Youtube'
                    rel='noreferrer'
                  >
                    <svg
                      width='33'
                      height='22'
                      viewBox='0 0 33 22'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M27.3176 22H5.31573C2.37182 22 0 19.3964 0 16.1941V5.80592C0 2.59053 2.38374 0 5.31573 0H27.3176C30.2615 0 32.6333 2.60355 32.6333 5.80592V16.1941C32.6452 19.4095 30.2615 22 27.3176 22Z'
                        fill='#819099'
                      />
                      <path
                        d='M20.6707 11L12 6V16L20.6707 11Z'
                        fill='#022032'
                      />
                    </svg>
                  </a>
                </li>
              ) : (
                <li>
                  <svg
                    width='33'
                    height='22'
                    viewBox='0 0 33 22'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M27.3176 22H5.31573C2.37182 22 0 19.3964 0 16.1941V5.80592C0 2.59053 2.38374 0 5.31573 0H27.3176C30.2615 0 32.6333 2.60355 32.6333 5.80592V16.1941C32.6452 19.4095 30.2615 22 27.3176 22Z'
                      fill='#819099'
                    />
                    <path d='M20.6707 11L12 6V16L20.6707 11Z' fill='#022032' />
                  </svg>
                </li>
              )}

              {/* Linkedin */}
              {socialLinks.flipboard?.indexOf('flipboard') !== -1 ? (
                <li>
                  <a
                    href={socialLinks.flipboard}
                    target='_blank'
                    alt='Linkedin'
                    rel='noreferrer'
                  >
                    <svg
                      width='24'
                      height='22'
                      viewBox='0 0 24 22'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <rect width='9' height='22' fill='#819099' />
                      <rect x='9' width='14.67' height='7' fill='#819099' />
                      <rect
                        x='9'
                        y='7'
                        width='7.33'
                        height='7.33'
                        fill='#819099'
                      />
                    </svg>
                  </a>
                </li>
              ) : (
                <li>
                  <svg
                    width='24'
                    height='22'
                    viewBox='0 0 24 22'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <rect width='9' height='22' fill='#819099' />
                    <rect x='9' width='14.67' height='7' fill='#819099' />
                    <rect
                      x='9'
                      y='7'
                      width='7.33'
                      height='7.33'
                      fill='#819099'
                    />
                  </svg>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      <InfoLane />
      <SocialLane />
    </>
  );
};

export default Footer;
